import classNames from 'classnames';
import * as React from 'react';

import StringUtils from '../../../utils/StringUtils';
import css from './BooksTermsOfUse.module.scss';

interface Props {
  className?: string;
  text: string;
}

const BooksTermsOfUse = ({ className, text }: Props) => {
  const classes = classNames(css.BooksTermsOfUse, className);
  return (
    <div className={classes}>
      <p className={css.BooksTermsOfUse__Text}>{StringUtils.nl2br(text)}</p>
    </div>
  );
};

export default BooksTermsOfUse;
